import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_QUOTE_FUNNELS_PRICES,

} from "./actionTypes"

import {
  getQuoteFunnelsPricesSuccess,
  getQuoteFunnelsPricesError,

} from "./actions"

import {

  genericGetRequest,
} from "../../helpers/sf_backend_helper"
import { AppConfiguration } from "config"
import { getCurrentBrandFromLocalStorage } from "helpers/sf_utils"

function* onGetQuoteFunnelsPrices(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/quote_funnels_prices`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'brand-id': getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getQuoteFunnelsPricesSuccess(response))
  } catch (error) {
    yield put(getQuoteFunnelsPricesError(error))
  }
}


function* QuoteFunnelsPricesSaga() {
  yield takeEvery(GET_QUOTE_FUNNELS_PRICES, onGetQuoteFunnelsPrices)
}

export default QuoteFunnelsPricesSaga

